import CoordinatorViewTraAtd from '../../features/coordinator/CoordinatorViewTraAtd'

const CoordinatorViewTraAtdPage = () => {
  return <CoordinatorViewTraAtd/>
}

export default CoordinatorViewTraAtdPage